import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  return (
    <main className="not-found" role="main" aria-label="Page not found">
      <div className="not-found__inner">
        <h1 className="not-found__code" aria-hidden="true">404</h1>
        <p className="not-found__message">
          The page you're looking for can't be found.
        </p>
        <div className="not-found__actions">
          <Link to="/" className="not-found__btn not-found__btn--primary">
            Go Home
          </Link>
        </div>
      </div>
    </main>
  );
}
